// REPLAY CONFIG — va-benefit-to-keys. Unresolved values stay empty/null until confirmed (see PRELAUNCH.md).
export const REPLAY = {
  videoUrl: "", // [[WEBINAR REPLAY VIDEO URL — NEEDS CONFIRMATION]]
  posterUrl: "", // [[REPLAY POSTER IMAGE URL — NEEDS CONFIRMATION]]
  durationLabel: "", // [[REPLAY DURATION — NEEDS CONFIRMATION]]
  durationSeconds: null,
  accessMode: null, // [[EVERGREEN OR FIXED WINDOW — NEEDS CONFIRMATION]] — all expiration UI hidden while null
  expiresAt: null, // [[ONLY IF A REAL EXPIRATION EXISTS — NEEDS CONFIRMATION]]
  calendarEmbedUrl: "", // [[GHL STRATEGY SESSION CALENDAR EMBED — NEEDS CONFIRMATION]]
};

// Single provider adapter: YouTube / Vimeo / Wistia / direct-GHL url → embeddable iframe src
export function embedUrlFor(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0`;
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?autoplay=1`;
  const ws = url.match(/wistia\.(?:com|net)\/(?:medias|embed\/iframe)\/([\w]+)/);
  if (ws) return `https://fast.wistia.net/embed/iframe/${ws[1]}?autoPlay=true`;
  return url;
}

export const REPLAY_TICKER_ITEMS = [
  "BENEFIT TO KEYS",
  "VERIFY → MODEL → MOVE",
  "ELIGIBILITY QUESTIONS",
  "BUYING-POWER INPUTS",
  "CASH CATEGORIES",
  "OPTIONAL PRIVATE SESSION",
];

// [[COMPLIANCE TO REVIEW — REPLAY FOOTER DISCLOSURE WORDING]]
export const REPLAY_DISCLOSURE =
  "This educational webinar replay is not a commitment to lend. Viewing it or attending an initial educational conversation does not constitute a loan application. No hard credit pull is required merely to view the replay or attend the initial educational conversation. All loans are subject to application, borrower and property eligibility, credit review, documentation, program guidelines, and underwriting approval. Interest rates, loan terms, payments, costs, and program availability may change and vary by borrower and transaction. Results are not guaranteed. VA home loan eligibility requires qualifying service or other qualifying status and is subject to verification. VA financing is not offered by the Department of Veterans Affairs itself, and this replay is not sponsored by, endorsed by, or affiliated with the U.S. Department of Veterans Affairs or any government agency. Chaunci Witherspoon, MBA, NMLS #1703351; Kinsfolk Mortgage LLC, Company NMLS #2610890; licensed in Florida. Equal Housing Lender. Final wording is subject to Kinsfolk Mortgage compliance approval.";
